import type { JobSeekerProfileStructuredDataSentiment } from "../../../../../../../../__generated__/types.gqlgenerated";

import { useAddProfilePreferenceMutation } from "./__generated__/useSavePreferenceAndValidateResult.gqlgenerated";
import Sentiment from "../../../../../../../../shared/util/salary/Sentiment";

import { useCallback } from "react";

export function useSavePreferenceAndValidateResult() {
  const [addProfilePreferenceMutation] = useAddProfilePreferenceMutation();
  return useCallback(
    async (suid: string, sentiment: Sentiment) => {
      const newSentiment: JobSeekerProfileStructuredDataSentiment =
        sentiment === Sentiment.POSITIVE ? "POSITIVE" : "NEGATIVE";
      const variables = {
        suid,
        sentiment: newSentiment,
      };
      const { data } = await addProfilePreferenceMutation({ variables });
      if (!data || !data.addJobSeekerProfileStructuredDataPreferenceAttributes) {
        throw new Error(`save ${sentiment} preference call returned no data for attribute ${suid}`);
      }
      const { preference, dislikedPreference } =
        data.addJobSeekerProfileStructuredDataPreferenceAttributes;

      const preferencesToCheck = newSentiment === "POSITIVE" ? preference : dislikedPreference;
      const savedAttribute = preferencesToCheck?.attributes.find(
        (attribute: { suid: string }) => attribute.suid === suid,
      );

      if (!savedAttribute) {
        throw new Error("preference was not actually saved");
      }

      return savedAttribute;
    },
    [addProfilePreferenceMutation],
  );
}
